import { FC, ReactNode } from 'react';

import { useTranslation } from 'utils/i18n';

interface Space {
  name: string;
}

interface Props {
  space: Space;
  onChange?: () => void;
  onRemove?: () => void;
  changeLabel?: string;
  removeLabel?: string;
}

const SpaceDetails: FC<Props> = ({
  space: { name } = {},
  onChange: change,
  onRemove: remove,
  changeLabel,
  removeLabel,
}) => {
  const { t } = useTranslation('common');
  const defaultChangeLabel =
    changeLabel || t('advanced_booking.space.change_room');
  const defaultRemoveLabel = removeLabel || t('advanced_booking.space.remove');

  const links = [
    ...(change
      ? [
          <a key="change" onClick={change} href="#">
            {defaultChangeLabel}
          </a>,
        ]
      : []),
    ...(remove
      ? [
          <a key="remove" onClick={remove} href="#">
            {defaultRemoveLabel}
          </a>,
        ]
      : []),
  ].reduce<ReactNode[]>(
    (prev, curr) => (prev.length === 0 ? [curr] : [...prev, ' | ', curr]),
    []
  );

  return (
    <div className="calendar__space_details">
      <h4>{name}</h4>
      <div>{links}</div>
    </div>
  );
};

export default SpaceDetails;
